import React from "react";
import { useNavigate } from "react-router-dom";

const LifeSaving = ()=>{
const navigate = useNavigate();

const scrollToTop = (location) => {

    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(location)
  };


return(
<div className="life-saving">


<h2 className="module-title">Life-Saving Rules Courses</h2>

<div className="life-saving-pic"></div>


<p className="reading-text"> <a href= "https://www.iogp.org/workstreams/safety/safety/life-savingrules/" > The Life-Saving Rules </a> is VR training that is also delivered as 360 degrees PC training that can be played using a mouse and keyboard. It is a fun tool to further educate
workers and promote a safe working environment. The Life-Saving Rules are an industry standard and have contributed to a significant reduction in fatal accidents. Playing the game ensures that the workers know the Life-Saving
Rules. The Life-Saving Rules consist of three training games that demonstrate how fun and safety can go hand in hand.
</p>

<p className="blue-text">Life-Saving Rules Games</p>

<ul className="lsr-ul">

    <li >
        <a href="https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/LSR+Aware.mp4" target="_blank" rel="noopener noreferrer">

        <img src="/mainImages/lsr-aware.png" alt="Life-Saving Rules Aware"className="lsr-aware-image" />
        </a>
    </li>
    <li >
        <a href="https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/LSR+Pro.mp4" target="_blank" rel="noopener noreferrer">

        <img src="/mainImages/lsr-pro.png" alt="Life-Saving Rules Pro"className="lsr-aware-image" />
        </a>
    </li>
    <li >
        <a href="https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Life-Saving+Rules+Road+1.mp4" target="_blank" rel="noopener noreferrer">

        <img src="/mainImages/lsr-roads.png" alt="Life-Saving Rules Road"className="lsr-aware-image" />
        </a>
    </li>
</ul>

<p className="blue-text">Benefits of Life-Saving Rules Training </p>
<p className="orange-bold">Superior Recollection and Understanding</p>

<div className="reading-text">
The design of the Life-Saving Rules training goes much deeper than fun. Recollection
and understanding of the rules are boosted in multiple ways:

<ul>
    <li className="bullets">Visual presentation of the rules</li>
    <li className="bullets">Animations to explain the issues in the field</li>
    <li className="bullets">Providing feedback on the user interaction</li>
    <li className="bullets">High-energy game playing holds the attention</li>
    <li className="bullets">The rules are spoken and written are given in the native language of the worker</li>
    <li className="bullets">Competitive element encouraging replaying to improve</li>
    <li className="bullets">Completing the Life-Saving Rules training ensures the Life-Saving Rules are known,
    understood, and recognized in the work environment</li>
</ul>
</div>
<p className="orange-bold">Exceptional Learning Method Giving Increased Employee Performance </p>

<p className="reading-text">The Life-Saving Rules Aware™ training is a big improvement over classical classroom training and e-learning.
</p>
<ul className="bar-margin">

    <img src = "/lifeSavingImages/bar-chart.png"  height={500} className="training-image"/>

</ul>

<p className="orange-bold">Comprehensive Curriculum </p>

<p className="reading-text"> VIRSAT has training for specific target groups, such as drivers, persons working in confined spaces, etc. This training is available on Virtual Reality headsets and 360 degrees PC training. </p>

<div className="bottom-pic">
    <h2 className="bottom-title">Access the Life-Saving  <span className="orange-text">Rules </span>™ </h2>
    <button className="body-button" id="button-position" onClick={()=>scrollToTop('/pclicense')}>Access to Play</button>
    <button className="other-games" onClick={()=>scrollToTop('/driving-pro')}>Driving Safety Games</button>
</div>

</div>
)
}

export default LifeSaving;
